export class MediaRefModel {
  src: string;
  resource: string;
  typeofnode: string;
  name: string;
  title: string;
  tenantId: string;
  constructor(
    src: string,
    resource: string,
    typeofnode: string,
    name: string,
    title: string,
    tenantId: string
  ) {
    this.src = src;
    this.resource = resource;
    this.typeofnode = typeofnode;
    this.name = name;
    this.title = title;
    this.tenantId = tenantId;
  }
}

export class MediaObjectModel {
  medias: MediaRefModel[];
  constructor(medias: MediaRefModel[]) {
    this.medias = medias ? medias : null;
  }
}
